import { SHAKE_KEYFRAMES } from "@digits-shared/components/UI/Elements/Form/InputStyles"
import colors from "@digits-shared/themes/colors"
import fonts from "@digits-shared/themes/typography"
import styled, { css } from "styled-components"

export const RegisterMessage = styled.div`
  color: ${colors.orange};

  font-weight: ${fonts.weight.normal};
  margin: 10px auto;
  font-size: 12px;
`

export const ButtonWrapper = styled.div<{ disabled?: boolean }>`
  align-self: center;
  cursor: pointer;
  width: 100%;

  ${({ disabled }) =>
    disabled &&
    css`
      &:active {
        animation: ${SHAKE_KEYFRAMES} 500ms forwards;
      }
    `}
`
